import {
  library,
} from '@fortawesome/fontawesome-svg-core'
import {
  faPenToSquare,
} from '@fortawesome/pro-solid-svg-icons'
import {
  faMapLocationDot,
  faPlane,
  faPlaneDeparture,
  faCalendarAlt,
  faUserFriends,
} from '@fortawesome/pro-duotone-svg-icons'

export default defineNuxtPlugin(() => {
  library.add({
    faPenToSquare,
    faMapLocationDot,
    faPlane,
    faPlaneDeparture,
    faCalendarAlt,
    faUserFriends,
  })
})
